// extracted by mini-css-extract-plugin
export default {"Registration_wrapper":"Registration_login_Registration_wrapper__9iG4E"};